export default __webpack_public_path__ + "static/media/main-hero.edccc2e1.webp";